export function urlQueryObjectToString(query: { [key: string]: any }): string {
  let queryString = '?'
  Object.keys(query).forEach((key, index) => {
    const divider = index > 0 ? '&' : ''
    queryString += `${divider}${key}=${query[key]}`
  })
  return queryString
}


// Return algolia suitable numeric filters from query
export function urlQueryToAlgoliaNumericFilters(query: { [key: string]: any }): string[] {
  const filters: string[] = [];
  const min = query.price_min;
  const max = query.price_max;
  if (min) filters.push(`price>=${min}`);
  if (max && max != "8000+") filters.push(`price<=${max}`);
  return filters;
}

// Return algolia suitable filters from query
export function urlQueryToAlgoliaFilters(query: { [key: string]: any }): string {
  const filters: any[] = [];

  // Parse techniques form query
  const techniques = query.techs;
  if (techniques && techniques.length) {
    filters.push(`(${mapQueryToFilter(techniques, 'technique.slug')})`)
  }

  // Parse themes form query
  const themes = query.themes;
  if (themes && themes.length) {
    filters.push(`(${mapQueryToFilter(themes, 'themes.id')})`);
  }

  // Parse sizes form query
  const sizes = query.sizes;
  if (sizes && sizes.length) {
    filters.push(`(${mapQueryToFilter(sizes, 'size_range')})`);
  }

  // Parse orientations form query
  const orientations = query.orientations;
  if (orientations && orientations.length) {
    filters.push(`(${mapQueryToFilter(orientations, 'orientation')})`);
  }

  // Parse color form query
  const color = query.color;
  if (color && color.length) {
    filters.push(`(${mapQueryToFilter(color, 'colors.en')})`);
  }

  // Additional filters
  const framed = query.framed;
  if (framed) filters.push("is_framed=1");
  const ready_to_hang = query.ready_to_hang;
  if (ready_to_hang) filters.push("is_hang_ready=1");
  const for_sale = query.for_sale;
  if (for_sale) filters.push("is_for_sale=1");
  const video = query.video;
  if (video) filters.push("is_video_approved=1")

  return filters.join(" AND ");
}


// Helper function for urlQueryToAlgoliaFilters
function mapQueryToFilter(query: string, filterType: string) {
  return query
    .split(",")
    .map(item => `${filterType}:${item}`)
    .join(" OR ");
}
